import { Box, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';

const keyCapSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 24,
  minHeight: 20,
  p: 0.25,
  borderRadius: 0.5,
  bgcolor: 'action.selected',
  color: 'text.primary',
  boxShadow: 'var(--mui-palette-common-shadows-keyCap)',
  typography: 'body2',
  fontWeight: 'fontWeightMedium',
  lineHeight: 1,
  whiteSpace: 'nowrap',
};

// Figma: pressed → resting over 300ms ease-out (Keyboard shortcuts, key-cap flash spec).
const flashSx = {
  '@keyframes keycap-flash': { from: { bgcolor: 'primary.main', color: 'primary.contrastText' } },
  animation: 'keycap-flash 300ms ease-out',
} as const;

export interface KeyCapProps {
  children: ReactNode;
  /** Increment to flash the cap (e.g. once per keydown): the cap remounts and replays pressed → resting. */
  flashSignal?: number;
  sx?: SxProps<Theme>;
}

/** A keyboard key badge — shortcut lists and the market menu hint row. */
export function KeyCap({ children, flashSignal, sx }: KeyCapProps) {
  return (
    <Box
      key={flashSignal}
      component="kbd"
      sx={[keyCapSx, !!flashSignal && flashSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    >
      {children}
    </Box>
  );
}
